export default __webpack_public_path__ + "static/media/tip4.9d0181b5.png";